export const CalendarDataFromExercise = {
  'feeling-estimation': {
    'Not well':
      {
        image: require('../../pages/WorkoutFeedback/workout-feedback-img/not-well-img.png'),
        description:
          'Cítili ste sa zle po tréningu.',
      },
    'I’m OK':
      {
        image: require('../../pages/WorkoutFeedback/workout-feedback-img/ok-img.png'),
        description:
          'Cítili ste sa dobre po tréningu.',
      },
    'Not tired':
      {
        image: require('../../pages/WorkoutFeedback/workout-feedback-img/not-tired-img.png'),
        description:
          'Cítili ste sa skvele po tréningu.',
      },
  },

  'workout-exertion': {
    'Difficult':
      {
        description: 'Tréning bol pre vás náročný, odporúčame znížiť intenzitu.',
      },
    'Perfect':
      {
        description: 'Tréning je pre vás ideálny, odporúčame nezmeniť intenzitu.',
      },
    'Too easy':
      {
        description: 'Tréning bol pre vás ľahký, odporúčame zvýšiť intenzitu.',
      },
  },

  'training-images': {
    'Morning Routine': require('../../pages/WorkoutPage/img-workout/avocadoes/avocado-morning.png'),
    'Hips, Butt and Thighs': require('../../pages/WorkoutPage/img-workout/avocadoes/avocado-hips.png'),
    'Burn Belly Fat': require('../../pages/WorkoutPage/img-workout/avocadoes/avocado-burn.png'),
    'Full-Body Workout': require('../../pages/WorkoutPage/img-workout/avocadoes/avocado-full-body.png'),
    'Toned Arms and Chest': require('../../pages/WorkoutPage/img-workout/avocadoes/avocado-toned-arms.png'),
    'Maximum Weight Loss': require('../../pages/WorkoutPage/img-workout/avocadoes/avocado-maximum-weight-loss.png'),
  }
}